export const CLOSE_ERROR_POPUP_WITHDRAWAL_REPORT_ERROR = 'CLOSE_ERROR_POPUP_WITHDRAWAL_REPORT_ERROR' as const;
export const GET_WITHDRAWAL_REPORT_REQUEST = 'GET_WITHDRAWAL_REPORT_REQUEST' as const;
export const GET_WITHDRAWAL_REPORT_SUCCESS = 'GET_WITHDRAWAL_REPORT_SUCCESS' as const;
export const GET_WITHDRAWAL_REPORT_ERROR = 'GET_WITHDRAWAL_REPORT_ERROR' as const;

export const GET_GLOBAL_WITHDRAWAL_EXCEL_REPORT_REQUEST = 'GET_GLOBAL_WITHDRAWAL_EXCEL_REPORT_REQUEST' as const;
export const GET_GLOBAL_WITHDRAWAL_EXCEL_REPORT_SUCCESS = 'GET_GLOBAL_WITHDRAWAL_EXCEL_REPORT_SUCCESS' as const;
export const GET_GLOBAL_WITHDRAWAL_EXCEL_REPORT_ERROR = 'GET_GLOBAL_WITHDRAWAL_EXCEL_REPORT_ERROR' as const;
